import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import { useState, useEffect } from "react";
import AwesomeIcon from "../AwesomeIcon";
import { faCalendar, faUser, faCircleCheck, faCircleExclamation, faClipboardList, faSpinner } from "@fortawesome/pro-regular-svg-icons";
import { truncate } from "lodash";
import { parse } from "best-effort-json-parser";
import { useStoreState } from "pullstate";
import Store from "../../utils/Store";
export default function PatientSummary(_ref) {
  var _patientData$patient, _patientData$patient2, _patientData$patient3, _patientData$patient4, _patientData$patient5, _patientData$timeline, _patientData$timeline2;
  var message = _ref.message;
  var _useState = useState({
      date: "",
      patient: {
        id: "",
        fullName: "",
        gender: "",
        age: 0,
        demographics: []
      },
      overview: "",
      timeline: []
    }),
    patientData = _useState[0],
    setPatientData = _useState[1];
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        accessPastChat: s.accessPastChat
      };
    }),
    accessPastChat = _useStoreState.accessPastChat;
  useEffect(function () {
    if (message.length > 0) {
      var jsonMatchMarkdown = message.match(/```(?:json)?\s*([\s\S]*)/i);
      var messageData = message.split("<<<PATIENT_SUMMARY_JSON>>>")[1];
      // let messageData = message;
      // if (jsonMatchMarkdown) {
      //   messageData = jsonMatchMarkdown[1];
      // }

      try {
        var parsedMessageData = parse(messageData);
        setPatientData(parsedMessageData);
      } catch (error) {
        console.error({
          error: error
        });
      }
    }
  }, [message, accessPastChat]);
  var _useState2 = useState(["timeline-20250408-0"]),
    openItems = _useState2[0],
    setOpenItems = _useState2[1];
  if (patientData === null) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center my-2 mx-4"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faSpinner,
      size: "lg",
      className: "animate-spin"
    }), /*#__PURE__*/React.createElement("p", {
      className: "text-md italic pl-4"
    }, "Patient Summary is loading..."));
  }
  var formatDate = function formatDate(dateString) {
    try {
      var date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return dateString; // Return original string if date is invalid
      }
      return date.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric"
      });
    } catch (error) {
      return dateString; // Return original string if parsing fails
    }
  };

  // Generate a unique ID for each timeline item
  var generateTimelineId = function generateTimelineId(date, index) {
    return "timeline-".concat(date === null || date === void 0 ? void 0 : date.replace(/-/g, ""), "-").concat(index);
  };
  var toggleItem = function toggleItem(value) {
    setOpenItems(openItems.includes(value) ? openItems.filter(function (item) {
      return item !== value;
    }) : [].concat(_toConsumableArray(openItems), [value]));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "h-full bg-gray-400 dark:bg-gray-950 border-gray-300 rounded-lg rounded-tl-none text-gray-200"
  }, /*#__PURE__*/React.createElement("div", {
    className: "max-w-2xl mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dark:bg-gray-900 bg-gray-100 shadow-md overflow-hidden border-0 rounded-lg rounded-tl-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4 border-b border-gray-300 dark:border-gray-700 flex justify-between items-center bg-gray-600 dark:bg-gray-800"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-lg font-medium text-white"
  }, "Clinical Summary")), /*#__PURE__*/React.createElement("span", {
    className: "text-sm dark:text-gray-300 text-gray-100"
  }, formatDate(patientData === null || patientData === void 0 ? void 0 : patientData.date))), /*#__PURE__*/React.createElement("div", {
    className: "p-4 border-b dark:border-gray-800 border-gray-300 flex items-center gap-3 border dark:border-gray-700"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-8 w-8 rounded-full dark:bg-gray-800 bg-gray-200 flex items-center justify-center"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faUser,
    className: "h-5 w-5 text-[#FFA387]"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-start"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-lg font-medium dark:text-white text-gray-700 break-words"
  }, patientData !== null && patientData !== void 0 && (_patientData$patient = patientData.patient) !== null && _patientData$patient !== void 0 && _patientData$patient.fullName ? truncate(patientData === null || patientData === void 0 || (_patientData$patient2 = patientData.patient) === null || _patientData$patient2 === void 0 ? void 0 : _patientData$patient2.fullName, {
    length: 25
  }) : "Patient"), /*#__PURE__*/React.createElement("span", {
    className: "text-md dark:text-gray-300 text-gray-800 dark:bg-gray-800 bg-gray-300 px-1.5 py-0.5 rounded"
  }, patientData === null || patientData === void 0 || (_patientData$patient3 = patientData.patient) === null || _patientData$patient3 === void 0 ? void 0 : _patientData$patient3.age, "Y ", patientData === null || patientData === void 0 || (_patientData$patient4 = patientData.patient) === null || _patientData$patient4 === void 0 ? void 0 : _patientData$patient4.gender)), /*#__PURE__*/React.createElement("p", {
    className: "text-sm dark:text-gray-300 text-gray-800 mt-1",
    dangerouslySetInnerHTML: {
      __html: patientData === null || patientData === void 0 || (_patientData$patient5 = patientData.patient) === null || _patientData$patient5 === void 0 || (_patientData$patient5 = _patientData$patient5.demographics) === null || _patientData$patient5 === void 0 ? void 0 : _patientData$patient5.join(" • ")
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "p-4 border dark:border-gray-800 border-gray-300"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2 mb-3"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCircleCheck,
    className: "h-5 w-5 text-teal-400"
  }), /*#__PURE__*/React.createElement("h2", {
    className: "text-lg font-medium text-teal-400"
  }, "Clinical Overview")), /*#__PURE__*/React.createElement("div", {
    className: "text-md dark:text-gray-200 text-gray-600 leading-relaxed",
    dangerouslySetInnerHTML: {
      __html: patientData === null || patientData === void 0 ? void 0 : patientData.overview
    }
  })), /*#__PURE__*/React.createElement(React.Fragment, null, (patientData === null || patientData === void 0 || (_patientData$timeline = patientData.timeline) === null || _patientData$timeline === void 0 ? void 0 : _patientData$timeline.length) > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "px-4 py-3 border dark:border-gray-800 border-gray-300 flex items-center gap-2"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCalendar,
    className: "h-5 w-5 text-teal-400"
  }), /*#__PURE__*/React.createElement("h2", {
    className: "text-lg font-medium text-teal-400"
  }, "Timeline of Events")), /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, patientData === null || patientData === void 0 || (_patientData$timeline2 = patientData.timeline) === null || _patientData$timeline2 === void 0 ? void 0 : _patientData$timeline2.map(function (timelineItem, index) {
    var _timelineItem$events, _timelineItem$events2, _timelineItem$events3;
    var dateId = generateTimelineId(timelineItem.date, index);
    var formattedDate = formatDate(timelineItem.date);
    var isOpen = openItems.includes(dateId);
    return /*#__PURE__*/React.createElement("div", {
      key: dateId,
      className: "border dark:border-gray-800 border-gray-300"
    }, /*#__PURE__*/React.createElement("button", {
      className: "flex w-full items-center justify-between px-4 py-3 hover:bg-gray-400/50 dark:hover:bg-gray-800/50 dark:text-white text-gray-600",
      onClick: function onClick() {
        return toggleItem(dateId);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-base font-medium"
    }, formattedDate), /*#__PURE__*/React.createElement("span", {
      className: "text-md ml-3 px-4 py-1 rounded-full dark:bg-gray-800 bg-gray-200 text-gray-600 dark:text-gray-300"
    }, timelineItem === null || timelineItem === void 0 || (_timelineItem$events = timelineItem.events) === null || _timelineItem$events === void 0 ? void 0 : _timelineItem$events.length, " events")), /*#__PURE__*/React.createElement("svg", {
      className: "h-4 w-4 transition-transform ".concat(isOpen ? "rotate-180" : ""),
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor"
    }, /*#__PURE__*/React.createElement("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M19 9l-7 7-7-7"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "overflow-hidden transition-all ".concat(isOpen ? "max-h-[1000px]" : "max-h-0")
    }, /*#__PURE__*/React.createElement("div", {
      className: "px-0 pb-0 pt-0"
    }, (timelineItem === null || timelineItem === void 0 || (_timelineItem$events2 = timelineItem.events) === null || _timelineItem$events2 === void 0 ? void 0 : _timelineItem$events2.length) > 0 && (timelineItem === null || timelineItem === void 0 || (_timelineItem$events3 = timelineItem.events) === null || _timelineItem$events3 === void 0 ? void 0 : _timelineItem$events3.map(function (event, eventIndex) {
      var _event$type, _timelineItem$events4, _event$items, _event$items2;
      // Determine icon and color based on event type
      var EventIcon = faClipboardList;
      var accentColor = "#5EEAD4"; // teal by default

      if (event !== null && event !== void 0 && (_event$type = event.type) !== null && _event$type !== void 0 && _event$type.includes("Imaging")) {
        EventIcon = faCircleExclamation;
        accentColor = "#FFA387"; // peach for imaging
      }
      return /*#__PURE__*/React.createElement("div", {
        key: "event-".concat(eventIndex),
        className: "px-4 py-3 ".concat(eventIndex < (timelineItem === null || timelineItem === void 0 || (_timelineItem$events4 = timelineItem.events) === null || _timelineItem$events4 === void 0 ? void 0 : _timelineItem$events4.length) - 1 ? "border-b dark:border-gray-800/50 border-gray-300" : "", " ").concat(eventIndex % 2 === 0 ? "dark:bg-gray-800/20 bg-gray-300/20" : "dark:bg-gray-800/10 bg-gray-300/10")
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex items-start gap-3 mb-2"
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: EventIcon,
        className: "h-5 w-5 mt-0.5 text-[#FFA387]"
      }), /*#__PURE__*/React.createElement("h3", {
        className: "text-normal font-medium dark:text-white text-gray-600"
      }, event === null || event === void 0 ? void 0 : event.type)), /*#__PURE__*/React.createElement("ul", {
        className: "space-y-2 text-md pl-6"
      }, (event === null || event === void 0 || (_event$items = event.items) === null || _event$items === void 0 ? void 0 : _event$items.length) > 0 && (event === null || event === void 0 || (_event$items2 = event.items) === null || _event$items2 === void 0 ? void 0 : _event$items2.map(function (item, itemIndex) {
        return /*#__PURE__*/React.createElement("li", {
          key: "item-".concat(itemIndex),
          className: "dark:text-gray-200 text-gray-500 flex items-start "
        }, /*#__PURE__*/React.createElement("span", {
          className: "mr-2 mt-1 text-[#FFA387]"
        }, "\u2022"), /*#__PURE__*/React.createElement("span", null, item));
      }))));
    })))));
  })))), /*#__PURE__*/React.createElement("div", {
    className: "p-4 text-md dark:text-gray-300 text-gray-600 dark:bg-gray-800/50 bg-gray-200 border-t dark:border-gray-800 border-gray-300"
  }, "Please refer to medical guidance for a comprehensive follow-up on AI interpretations and treatment contexts for this patient."))));
}